var Curriculog = Curriculog || {};

Curriculog.List = (function ($, _, Backbone, List) {

	List = Backbone.View.extend({
		el: function() {
			return $('#curriculog-list-column');
		},

		initialize: function(options) {
			this.user = options.user;
			this.params = options.params;

			var html = this.render();
			$('#curriculog-list-column').replaceWith(html);
			this.setElement($('#curriculog-list-column'));
			this.handleTabChange();

			this.listenTo(Backbone, 'list:stretch', this.stretch);
			this.listenTo(Backbone, 'tabs:change', this.handleTabChange);
		},

		hideApproveWidget: function(){
			$('.approve-selected-widget').hide();
		},

		showApproveWidget: function(){
			$('.approve-selected-widget').show();
		},

		handleTabChange: function(event){
			var currentTab = this.params.domParams.get('tab');
			if ( currentTab === 'task' ){
				this.showApproveWidget();
			} else {
				this.hideApproveWidget();
			}
		},

		render: function() {
			return nunjucks.render('ProposalList/proposalList.html',
				{
					user: this.user.attributes,
					level: this.params.domParams.get('level'),
					isTaskTab: ( this.params.domParams.get('tab') === 'task' ),
          cui_enabled: this.params.cui_enabled,
          hasAccess: this.user.id > 0 || this.user.attributes.permissions.transparency_dashboard_view == 1
				}
			);
		},

		stretch: function() {
      if (!this.params.cui_enabled) {
        objDom.verticalStretchList();
      }
		}

	});

	return List;

})($, _, Backbone, Curriculog.List || {});
